<template>
  <div>
    <router-view/>
    <GlobalNavigationBar/>
  </div>
</template>
<script>
import GlobalNavigationBar from './components/GlobalNavigationBar.vue'
export default {
  components:{
    GlobalNavigationBar
  }
}
</script>
<style>
/* @import "./assets/layout.css"; */


nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active{
  color: #42b983;
}
</style>
